import { c as _c } from "react/compiler-runtime";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { getCreditPurchasesColumns } from "@components/table/transactions/credit-purchases-columns";
import { CreditPurchasesHistoryHeaders } from "@components/table/transactions/transactions-table-utils";
import { Alert } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { useTokenPurchase } from "@hooks/use-token-purchase";
import { Box } from "@mui-wrapper";
import { allCreditSubscriptionsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { TableType } from "@utils/track-event/track-event-list";
import { useMemo } from "react";

/** List of required columns in the credits purchases history table */
const requiredColumns = [CreditPurchasesHistoryHeaders.package, CreditPurchasesHistoryHeaders.purchasedDate, CreditPurchasesHistoryHeaders.expirationDate, CreditPurchasesHistoryHeaders.status, CreditPurchasesHistoryHeaders.creditsRemaining];

/** Renders the table for credits history */
export function CreditPurchasesTable() {
  const $ = _c(11);
  const {
    shouldShowNewIndication
  } = useTokenPurchase();
  const {
    formatDate
  } = useDateTime();
  const subscriptions = useAppSelector(allCreditSubscriptionsSelector);
  let t0;
  if ($[0] !== formatDate) {
    t0 = requiredColumns.map(requiredColumn => getCreditPurchasesColumns({
      formatDate
    })[requiredColumn]);
    $[0] = formatDate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tableColumns = t0;
  let t1;
  if ($[2] !== shouldShowNewIndication) {
    t1 = shouldShowNewIndication && <Alert variant="info" title="The most recent tokens you purchased will be available here shortly." sx={{
      marginY: "24px"
    }} />;
    $[2] = shouldShowNewIndication;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      overflow: "hidden"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== subscriptions || $[6] !== tableColumns) {
    t3 = <Box sx={t2}><FaroTable entities={subscriptions} uniqueIdKey="uiTemporaryId" isLoading={false} shouldHideCheckbox={true} columns={tableColumns} rowHeight={70} tableType={TableType.creditPurchases} /></Box>;
    $[5] = subscriptions;
    $[6] = tableColumns;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}